import React from 'react';
import { P5CanvasInstance, ReactP5Wrapper } from '@p5-wrapper/react';
import { Direction, Walker } from './Walker';

class MouseWalker extends Walker {
  step() {
    if (this.p5.random(1) < 0.5) {
      if (this.p5.mouseX > this.x && this.p5.mouseY > this.y) {
        super.step(Direction.DIAG_DOWN_RIGHT)
      } else if (
        this.p5.mouseX < this.x && this.p5.mouseY > this.y) {
        super.step(Direction.DIAG_DOWN_LEFT)
      } else if (
        this.p5.mouseX > this.x && this.p5.mouseY < this.y) {
        super.step(Direction.DIAG_UP_RIGHT)
      } else if (
        this.p5.mouseX < this.x && this.p5.mouseY < this.y) {
        super.step(Direction.DIAG_UP_LEFT)
      } else if (this.p5.mouseX > this.x) {
        super.step(Direction.RIGHT)
      } else if (this.p5.mouseX < this.x) {
        super.step(Direction.LEFT)
      } else if (this.p5.mouseY > this.y) {
        super.step(Direction.DOWN)
      } else if (this.p5.mouseY < this.y) {
        super.step(Direction.UP)
      }
    } else {
      super.step();
    }
  }
}

const MouseWalkerComponent: React.FC = (props) => {
  function sketch(p5: P5CanvasInstance) {
    let walker: Walker;

    p5.setup = () => {
      p5.createCanvas(640, 240);
      p5.background(240);
      walker = new MouseWalker(p5, p5.color(255, 0, 0));
    }

    p5.draw = () => {
      walker.step();
      walker.show();
    };
  }

  return <ReactP5Wrapper sketch={sketch} />;
};

export default MouseWalkerComponent;